import { useEffect } from 'react';
import { tr } from '@/i18n';

/** Sets `document.title` to `<title> · 20fight!` (or just the app name). */
export function useDocumentTitle(title: string | null | undefined): void {
  useEffect(() => {
    const app = tr.app.name;
    document.title = title ? `${title} · ${app}` : app;
  }, [title]);
}
